import { defineComponent as y, useSlots as h, inject as k, computed as n, createElementBlock as r, openBlock as i, Fragment as B, createBlock as l, createCommentVNode as s, resolveDynamicComponent as a, mergeProps as C, withCtx as D, renderSlot as d, toRaw as I } from "vue";
import { ListVariantKey as _ } from "@ds/components/TextList";
import { DefaultVariant as x } from "../TextList/TextList.constant.js";
import { tw as o } from "../../utils/tailwind.js";
const V = {
  key: 0,
  class: "text-static-default-hi body-2 ml-40 list-none"
}, E = /* @__PURE__ */ y({
  name: "RevTextListItem",
  inheritAttrs: !1,
  __name: "TextListItem",
  props: {
    icon: { default: void 0 }
  },
  setup(u) {
    const f = u, c = h(), e = k(_), m = n(() => ({
      definition: "dt",
      ordered: "li",
      unordered: "li"
    })[e?.value || x]), b = n(() => !!(e?.value !== "ordered" && f.icon)), p = n(() => [
      o`text-static-default-hi relative mt-16 list-none first:mt-0`,
      e?.value === "definition" && o`body-1-bold`,
      e?.value !== "definition" && o`body-1`,
      e?.value === "ordered" && o`pl-40 [counter-increment:list-item] before:bg-static-default-mid before:body-2-bold before:absolute before:left-0 before:inline-flex before:size-24 before:shrink-0 before:items-center before:justify-center before:rounded-[50%] before:[content:counters(list-item,'.')]`,
      e?.value !== "ordered" && o`pl-40`
    ]), v = n(() => !!(e?.value === "definition" && c.definition));
    return (t, g) => (i(), r(B, null, [
      (i(), l(a(m.value), C({ class: p.value }, t.$attrs), {
        default: D(() => [
          b.value ? (i(), l(a(I(t.icon)), {
            key: 0,
            class: "absolute left-0 top-0"
          })) : s("", !0),
          d(t.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"])),
      v.value ? (i(), r("dd", V, [
        d(t.$slots, "definition")
      ])) : s("", !0)
    ], 64));
  }
});
export {
  E as default
};
